function logTextToApi(response, email, error, datasource) {
    return false;
    const googleDataSource = "Generic Google Sheet DataSource";
    if ((email === "sanjeev4972@gmail.com" ||
        email.toLowerCase() === "Justin.RoffMarsh@ballistix.com".toLowerCase())
        && datasource === googleDataSource) {

        const logEntry = {
            message: JSON.stringify(response),
            level: 'info',
            error: error ? error.toString() : null,
            timestamp: new Date().toISOString(),
            UserEmail: email
        };

        try {
            fetch('https://dashboard-dev.nsyteful.com/app-api/api/Log', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(logEntry)
            }).catch(error => {
                console.error('Error logging text to API:', error);
            });
        } catch (err) { }

    }


}


export const LogTextToApiFun = logTextToApi;